import React, { useState, useEffect } from 'react';
import { Settings, User, MessageSquare, ShoppingCart, Globe, HelpCircle, Package } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Icon mapping function to get Lucide React icons by name
const getIconByName = (iconName) => {
  const icons = {
    'user': <User className="h-8 w-8" />,
    'message-square': <MessageSquare className="h-8 w-8" />,
    'shopping-cart': <ShoppingCart className="h-8 w-8" />,
    'globe': <Globe className="h-8 w-8" />,
    'help-circle': <HelpCircle className="h-8 w-8" />,
    'package': <Package className="h-8 w-8" />,
    // Add more icons as needed
  };
  
  return icons[iconName] || <HelpCircle className="h-8 w-8" />;  // Default icon if not found
};

const DashboardPage = () => {
    const navigate = useNavigate();
    const { user, loading: authLoading } = useAuth();
    const [userName, setUserName] = useState('Guest');
    const [customMessage, setCustomMessage] = useState('Il sole splende a Monza');
    
    useEffect(() => {
        // Only update the name when auth has finished loading
        if (!authLoading) {
          if (user && user.username) {
            // Use only the name property from user object
            setUserName(user.username);
          } else {
            // Fall back to a generic greeting if name is not available
            setUserName('Guest');
          }
        }
    }, [user, authLoading]);

    // Static menu items
    const menuItems = [
      { 
        page_name: 'Sito Web', 
        page_description: 'Vai al sito web di vorwerk repair', 
        redirect_url: 'https://prestige.vorwerk.repair',
        icon_name: 'globe'
      },
      { 
        page_name: 'Supporto', 
        page_description: 'Assistenza clienti', 
        redirect_url: 'https://supporto.vorwerk.repair',
        icon_name: 'message-square'
      },
      { 
        page_name: 'Prodotti', 
        page_description: 'Catalogo prodotti', 
        redirect_url: '/products',
        icon_name: 'package'
      }
    ];

    const handleItemClick = (url) => {
      // Handle external URLs
      if (url.startsWith('http')) {
        window.open(url, '_blank');
      } else {
        // Internal navigation
        navigate(url);
      }
    };

    return (
      <div className="flex h-screen bg-gray-100">
        {/* Left column */}
        <div className="w-1/3 p-6 bg-gray-50 flex flex-col">
          <div className="flex-1">
            <div className="bg-gray-200 rounded-lg p-6">
              <h1 className="text-4xl font-bold mb-2">Ciao {userName}</h1>
              <p className="text-xl">{customMessage}</p>
            </div>
            {/* Blank space is automatically created with flex-1 */}
          </div>
          <div className="flex items-center space-x-4 mt-auto mb-4">
            <button className="p-2 rounded-full hover:bg-gray-200">
              <Settings className="h-6 w-6 text-gray-600" />
            </button>
            <button className="p-2 rounded-full hover:bg-gray-200">
              <User className="h-6 w-6 text-gray-600" />
            </button>
          </div>
        </div>

        {/* Right column */}
        <div className="w-2/3 p-6">
          <div className="space-y-4">
            {menuItems.map((item, index) => (
              <div
                key={index}
                onClick={() => handleItemClick(item.redirect_url)}
                className="bg-gray-200 rounded-lg p-6 flex items-center justify-between cursor-pointer hover:bg-gray-300 transition-colors"
              >
                <div>
                  <h2 className="text-2xl font-semibold">{item.page_name}</h2>
                  {item.page_description && (
                    <p className="text-gray-600">{item.page_description}</p>
                  )}
                </div>
                <div className="text-gray-500">
                  {getIconByName(item.icon_name)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
};

export default DashboardPage;
